import type {
    WebSkillListParams,
    WebSkillListResponse,
    WebSkillDetailItem,
    WebSkillCreateRequest,
    WebSkillCreateData,
    WebSkillEnableData,
    WebSkillDeleteData,
    WebSkillUpdateRequest,
    WebSkillUpdateData,
    WebSkillImportRequest,
    WebSkillImportData,
    WebSkillSecurityCheckRequest,
    SkillSecurityCheckData,
    SharedSkillInfo,
    CreateSkillFromSkillIdData,
    WebSkillImportFromShareLinkRequest,
    WebSkillImportFromShareLinkData,
    SkillSharedResourceMetadata,
    SkillShareGenerateForm,
    SkillShareCreateData,
} from '../types';

export const SkillApiService = Symbol('SkillApiService');

export interface SkillApiService {
    getList(params?: WebSkillListParams): Promise<WebSkillListResponse>;
    getDetail(id: string): Promise<WebSkillDetailItem>;
    create(data: WebSkillCreateRequest): Promise<WebSkillCreateData>;
    update(id: string, data: WebSkillUpdateRequest): Promise<WebSkillUpdateData>;
    enable(id: string): Promise<WebSkillEnableData>;
    disable(id: string): Promise<WebSkillEnableData>;
    remove(id: string): Promise<WebSkillDeleteData>;
    exportSkill(id: string): Promise<Blob>;
    importSkill(data: WebSkillImportRequest): Promise<WebSkillImportData>;
    validateImportSecurity(data: WebSkillSecurityCheckRequest): Promise<SkillSecurityCheckData>;
    // 分享相关
    /** 生成技能分享链接。 */
    generateShareLink(skillId: string, data?: SkillShareGenerateForm): Promise<SkillShareCreateData>;
    /** 通过分享链接导入技能。GET /shared-resources 前需要密码时，passcode 走请求头。 */
    importFromShareLink(data: WebSkillImportFromShareLinkRequest): Promise<WebSkillImportFromShareLinkData>;
    /** 获取分享资源公开元数据。 */
    getSharedResourceMetadata(shareCode: string): Promise<SkillSharedResourceMetadata>;
    /** 分享落地页：读取分享资源信息（基于 getSharedResourceMetadata 适配）。 */
    getSharedSkillInfo(shareCode: string): Promise<SharedSkillInfo>;
    /** 分享落地页：安装（基于 importFromShareLink 适配）。 */
    createSkillFromSkillId(shareCode: string, passcode?: string): Promise<CreateSkillFromSkillIdData>;
}
